import { useEffect, useState } from 'react';
import { Dropdown, DropdownChangeEvent } from '../../Common/Imports';
import { DDModel } from '../../Models/Classes';


interface DDMailTemplateTypeProps {
    IdStakeholder?: number | null;
    onChange?: (IdBrand: number | string | undefined) => void;
    value?: number;
    onBlur?: () => void;
}


export const DDMailTemplateType: React.FC<DDMailTemplateTypeProps> = ({ value, onChange }) => {
    const [data] = useState<DDModel<number>[]>([{
        label: "Customer Email",
        id: 0,
        data: 0
    },
    {
        label: "Provider Email",
        id: 1,
        data: 1
    },
    {
        label: "Invoice Email",
        id: 2,
        data: 2
    }]);
    const [selectedElem, setSelectedElem] = useState<DDModel<number> | undefined>();

    useEffect(() => {
        setSelectedElem(data.find(m => m.id === value));
    }, [data, value]);

    const handleChange = (e: DropdownChangeEvent) => {
        const _val = e.value as DDModel<number>;
        setSelectedElem(_val);
        if (onChange && e) {
            onChange(_val.id);
        }
    };

    return (
        <Dropdown
            value={selectedElem}
            onChange={handleChange}
            options={data}
            optionLabel="label"
            className="w-100" />
    );
};
